module.exports = __webpack_public_path__ + "ef84f7793e063b0033e9f4449247267d.png";